import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ConfigurationPage, type ConfigTab, CONFIG_TABS } from "@/features/food-configuration/configuration-page";

export const Route = createFileRoute("/food-app/configuration")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): { tab?: ConfigTab } => ({
    tab: CONFIG_TABS.includes(search.tab as ConfigTab)
      ? (search.tab as ConfigTab)
      : undefined,
  }),
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <ConfigurationPage
      tab={tab ?? "formats"}
      onTabChange={(value) =>
        navigate({
          to: ".",
          search: { tab: value === "formats" ? undefined : (value as ConfigTab) },
          replace: true,
        })
      }
    />
  );
}
